import { Info } from 'lucide-react'

interface ManualFallbackDisclaimerProps {
  variant: 'welcome' | 'inline'
}

const LEGACY_FORM_URL = 'https://zota.com/application-form-financial-services/'

export function ManualFallbackDisclaimer({ variant }: ManualFallbackDisclaimerProps) {
  const isWelcome = variant === 'welcome'

  return (
    <div
      role="note"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 'var(--spacing-3)',
        background: 'var(--color-info-surface)',
        borderRadius: isWelcome ? 'var(--radius-lg)' : 'var(--radius-md)',
        // Match horizontal padding to the other Welcome-screen info boxes
        // (previous-submission banner uses spacing-4 / spacing-6).
        padding: isWelcome
          ? 'var(--spacing-4) var(--spacing-6)'
          : 'var(--spacing-3) var(--spacing-4)',
        marginBottom: isWelcome ? 'var(--spacing-8)' : 'var(--spacing-4)',
      }}
    >
      <Info
        size={isWelcome ? 20 : 18}
        aria-hidden="true"
        style={{ color: 'var(--color-action-primary)', flexShrink: 0, marginTop: 2 }}
      />
      <p
        style={{
          margin: 0,
          fontFamily: 'var(--font-body)',
          fontSize: isWelcome ? 'var(--text-body-sm)' : 'var(--text-label-sm)',
          color: 'var(--color-info-text)',
          lineHeight: 'var(--leading-normal)',
        }}
      >
        Prefer to fill this form manually?{' '}
        <a
          href={LEGACY_FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'var(--color-action-primary)',
            fontWeight: 'var(--weight-semibold)',
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
          }}
        >
          Use our classic application form
        </a>{' '}
        instead.
      </p>
    </div>
  )
}
